export default __webpack_public_path__ + "static/media/Gry miejskie_Sanja.375d1840.pdf";